var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatrixBubbleMobilecolors(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 340 378",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    width: 340,
    height: 378,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 378,
    fill: "#fff",
    rx: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M91 212.696h323.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M91 339.585h323.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M91 263.452h323.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M91 238.074h323.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M91 364.963h323.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M91 288.829h323.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M91 314.208l323.06-.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M106.739 494.381V197"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M277.682 494.382V197.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M175.118 494.382V197.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M140.929 494.382V197.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M311.872 494.382V197.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M209.304 494.382V197.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M243.493 494.382V197.001"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.041,
    cy: 213.11,
    r: 10.354,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.287,
    cy: 314.999,
    r: 10.354,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.794,
    cy: 339.849,
    r: 10.354,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.414,
    cy: 239.618,
    r: 10.354,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.795,
    cy: 288.49,
    r: 6.213,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.041,
    cy: 289.319,
    r: 6.213,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.003,
    cy: 238.789,
    r: 6.213,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.966,
    cy: 211.453,
    r: 6.213,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.324,
    cy: 365.528,
    r: 6.213,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.152,
    cy: 263.64,
    r: 6.213,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.698,
    cy: 339.849,
    r: 6.213,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.944,
    cy: 238.789,
    r: 6.213,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.72,
    cy: 340.677,
    r: 6.213,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.172,
    cy: 313.756,
    r: 2.485,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209.455,
    cy: 263.225,
    r: 2.485,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.701,
    cy: 288.905,
    r: 2.485,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.738,
    cy: 314.584,
    r: 2.485,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.701,
    cy: 365.114,
    r: 2.485,
    fill: "#DF4B85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.304,
    cy: 237.9,
    r: 4.215,
    fill: "#2C2664"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.59,
    cy: 365.199,
    r: 4.215,
    fill: "#2C2664"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.876,
    cy: 288.483,
    r: 4.215,
    fill: "#2C2664"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.59,
    cy: 289.326,
    r: 4.215,
    fill: "#2C2664"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.99,
    cy: 339.065,
    r: 4.215,
    fill: "#2C2664"
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgMatrixBubbleMobilecolors as ReactComponent };